function replaceFile(blob, file, dropzone) {
  var binaryFile = new File([blob], file.name);
  dropzone.files.splice(dropzone.files.findIndex(el => el == file.name || el.name == file.name), 1, binaryFile);
  dropzone.emit("thumbnail", file, URL.createObjectURL(blob));
}

function removeFile(file, dropzone) {
  $(file.previewElement).remove();
  dropzone.removeFile(dropzone.files.find(el => el == file.name || el.name == file.name));
}

function rotateFile(file, dropzone, degree) {
  var elem = $(file.previewElement).find('img')
    .get()[0];
  if (!elem.clone) {
    elem.clone = $(file.previewElement)
      .find('img').clone().css('display', 'none').appendTo('body').get()[0]
    new Cropper(elem.clone, {
      rotatable: true,
      ready: function () {
        this.cropper.cropper.hidden = true;
        this.cropper.clear();
        this.cropper.rotate(degree);
        this.cropper.getCroppedCanvas({
          imageSmoothingEnabled: false,
        }).toBlob(function (blob) {
          replaceFile(blob, file, dropzone);
        })
      }
    });
  } else {
    elem.clone.cropper.rotate(degree);
    elem.clone.cropper.getCroppedCanvas({
      imageSmoothingEnabled: true,
    }).toBlob(function (blob) {
      replaceFile(blob, file, dropzone);
    })

  }
}

//checkbox
global.modules.set({
  async init(context) {
    $('.dropzone', context).dropzone({
      url: '/',
      autoProcessQueue: false,
      previewsContainer: ".dropzone-previews",
      maxFilesize: 9,
      acceptedFiles: ".png, .jpg, .gif, .jpeg",
      maxFiles: 40,
      thumbnailWidth: null,
      thumbnailHeight: null,
      previewTemplate: $('.dropzone_template').html(),
      accept: function (file, done) {
        if (this.files.filter(el => el.name == file.name).length > 1) {
          done('Duplicate file');
        }
        if (this.files.length > this.options.maxFiles) {
          done('Limit reached (max 40 files)');
        }
      },
      init: function () {
        var dropzone = this;
        dropzone.on("error", function (file, message) {
          showNotificationPopup(message, 'error');
          this.removeFile(file);
        });
        dropzone.on('addedfile', function (file) {
          $('.dropzone-previews-order').show();
          var elem = $(file.previewElement);
          elem.find('.rotate_right').on('click', function () {
            rotateFile(file, dropzone, -90)
          })
          elem.find('.item-delete').on('click', function () {
            removeFile(file, dropzone);
          })
          elem.find('.rotate_left').on('click', function () {
            rotateFile(file, dropzone, 90)
          })
          var modal = $(dropzone.element).find('.modal__window');
          elem.find('.show_modal').on('click', function (e) {
            e.stopPropagation();
            modal.find('img').attr('src', $(file.previewElement).find('img').attr('src'));
            new Cropper(modal.find('img').get()[0], {
              autoCrop: true
            });
            modal.removeAttr('hidden').addClass('active');
            modal.find('.submit_crop').one('click', function () {
              if ($(file.previewElement).find('img').get()[0].clone) {
                $(file.previewElement).find('img').get()[0].clone.cropper.destroy();
                $($(file.previewElement).find('img').get()[0].clone).remove();
                $(file.previewElement).find('img').get()[0].clone = null;
              }
              var cropper = modal.find('img')[0].cropper;
              cropper.getCroppedCanvas({
                imageSmoothingQuality: 'high'
              }).toBlob(function (blob) {
                replaceFile(blob, file, dropzone);
              }, '', 1)
              modal.removeClass('active').trigger('hide');
            })
            modal.find('.cancel-cropping').one('click', function () {
              modal.removeClass('active').trigger('hide');
            })
          })
          modal.on('hide', function () {
            if (modal.find('img')[0].cropper) {
              modal.find('img')[0].cropper.destroy();
              modal.find('.submit_crop').off('click');
            }
          })
        })
        JSON.parse($(this.element).attr('value') || '[]').forEach(function (el) {
          dropzone.displayExistingFile({ name: el }, el);
          dropzone.files.push(el);
        })
        dropzone.on('removedfile', function (file) {
          if (this.files.includes(file.dataURL)) {
            this.files.splice(this.files.indexOf(file.dataURL), 1)
          }
          if (!this.files.length) {
            $('.dropzone-previews-order').hide();
          }
        })
      }
    });

    var reorder = dragula(Array.from(document.querySelectorAll('.dropzone-previews')));
    reorder.on('dragend', function () {
      var queue = $('.dropzone').get()[0].dropzone.files;
      var newQueue = [];
      $('.dropzone-previews').find('.item-img').each(function () {
        var name = $(this).attr('alt');
        var el = queue.find(function (el) {
          return el == name || el.name == name;
        });
        newQueue.push(el);
        queue.splice(queue.indexOf(el), 0)
      });
      $('.dropzone').get()[0].dropzone.files = newQueue;
    })
  }
})